import { render, staticRenderFns } from "./PostVentaDataIndex.vue?vue&type=template&id=2ca76d10&scoped=true"
import script from "./PostVentaDataIndex.vue?vue&type=script&lang=js"
export * from "./PostVentaDataIndex.vue?vue&type=script&lang=js"
import style0 from "./PostVentaDataIndex.vue?vue&type=style&index=0&id=2ca76d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca76d10",
  null
  
)

export default component.exports